import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { firstValueFrom } from 'rxjs';

export const isTokenValidGuard: CanActivateFn = async (
   next: ActivatedRouteSnapshot,
   state: RouterStateSnapshot
): Promise<boolean> => {

  const authService = inject(AuthService);
  const router = inject(Router);

  const email = next.queryParamMap.get('email');
  const token = next.queryParamMap.get('token');

  if (!email || !token) {
    router.navigate(['/auth/login']);
    return false;
  }

  const response = await firstValueFrom(authService.validateResetToken({ email, token }));
  if (response.status) {
    // Entering a reset flow with a GOOD link clears any verdict left over from
    // an earlier bad one. `isTokenValid` is a root-provided signal that lives
    // for the whole app lifetime, so without this a user who first clicked an
    // expired link and then a fresh one would carry the stale `false` into the
    // status page whenever navigation state was unavailable.
    authService.isTokenValid.set(null);
    authService.isTokenValidError.set(null);
    return true;
  } else {
    authService.isTokenValid.set(response.status);
    authService.isTokenValidError.set(response.errors[0]);
    // The verdict travels in navigation state as well as in the signals. State
    // is the primary channel — it is what `history.state` preserves across the
    // `window.location.reload()` that `AuthLayoutComponent` performs when a
    // sibling tab signs in, whereas the signals are lost with the JS context.
    router.navigate(['/auth/reset-password-status'], {
      state: { status: response.status, message: response.errors },
    });
    return false;
  }

};
